// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ps3vr","title":"styles_title__3rf-j"};